// Lib
import { useState } from "react";

// Components
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuTrigger,
} from "@/components/atoms/dropdown-menu";
import { Button } from "@/components/atoms/button";
import OrderAssignDriver from "@/components/orders/OrderAssignDriver";
import OrderCancellationModal from "@/components/modals/OrderCancellationModal";

// Icons
import { Bike, CircleX, EllipsisVertical } from "lucide-react";
import { Link } from "react-router-dom";

export default function OrderRowDropdown({
  order,
  onOrderStatusUpdate,
  onOrderDriverUpdate,
}: {
  order: any; // WTF?
  onOrderStatusUpdate: (orderId: number, newStatus: string) => void;
  onOrderDriverUpdate: (orderId: number, driver?: any) => void;
}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <DropdownMenu open={isOpen} onOpenChange={setIsOpen}>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="icon"
          onClick={(e: any) => {
            e.stopPropagation();
          }}
        >
          <EllipsisVertical width={18} height={18} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="bg-white p-2 flex flex-col rounded-md border border-gray-200 shadow-md"
        onClick={(e: any) => {
          e.stopPropagation();
        }}
      >
        <DropdownMenuLabel className="sr-only">Opciones</DropdownMenuLabel>
        {order.driver_id && (
          <DropdownMenuItem className="cursor-pointer flex items-center gap-2 p-2">
            <Link
              to={`/drivers/${order.driver_id}`}
              className="flex items-center gap-2 text-sm"
            >
              <Bike width={18} height={18} /> Seguimiento
            </Link>
          </DropdownMenuItem>
        )}

        <OrderAssignDriver
          order={order}
          onOrderDriverUpdate={onOrderDriverUpdate}
          onClose={() => {
            handleClose();
          }}
          trigger={
            <DropdownMenuItem
              className="cursor-pointer flex items-center gap-2 p-2"
              onSelect={(e: any) => {
                e.preventDefault();
              }}
            >
              <Bike width={18} height={18} />
              {order.driver_id ? "Reasignar conductor" : "Asignar conductor"}
            </DropdownMenuItem>
          }
        />
        {/* {order.driver_id !== null && (
          <OrderRemoveDriver
            order={order}
            onOrderDriverUpdate={onOrderDriverUpdate}
            onClose={() => {
              handleClose();
            }}
            trigger={
              <DropdownMenuItem
                className="cursor-pointer flex items-center gap-2 p-2 text-red-500"
                onSelect={(e: any) => {
                  e.preventDefault();
                }}
              >
                <X width={18} height={18} />
                Desasignar conductor
              </DropdownMenuItem>
            }
          />
        )} */}

        <OrderCancellationModal
          order={order}
          onOrderStatusUpdate={onOrderStatusUpdate}
          trigger={
            <DropdownMenuItem
              className="text-red-500 cursor-pointer flex items-center gap-2 p-2"
              onSelect={(e: any) => {
                e.preventDefault();
              }}
            >
              <CircleX width={18} height={18} />
              Cancelar orden
            </DropdownMenuItem>
          }
        />
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
